import React from 'react';
import { getData, getMenuId, reloadFunc } from '@util';
import { API_GET_USER_CENTER_PERMISSIONS_BANS } from '@api';

const GetAuthDataValue = React.createContext();

function withGetAuthWraper(WrappedCom) {
  return class extends React.Component {
    constructor(props) {
      super(props);
      this.state = {
        AuthData: [],
      };
    }

    UNSAFE_componentWillMount() {
      this.getAuthFunc();
    }

    getAuthFunc = async () => {
      let path = this.props.location.pathname;
      // 详情页用列表的权限配置
      if (path?.includes('/bbc/bbcGoodsView')) {
        path = '/bbc/GoodsManageMent';
      }
      if (path?.includes('/order/orderNoticeDes')) {
        path = '/order/orderNotice';
      }
      if (path?.includes('/order/orderAcceptDes')) {
        path = '/order/orderAccept';
      }
      if (path?.includes('/order/returnNoticeDes')) {
        path = '/order/returnNotice';
      }
      if (path?.includes('/order/returnFromDes')) {
        path = '/order/returnFrom';
      }
      const menuId = getMenuId(path);
      if (!menuId) {
        // reloadFunc();
        return false;
      }
      getData({
        api: API_GET_USER_CENTER_PERMISSIONS_BANS,
        urlParams: [menuId],
      }).then(res => {
        if (res && res.code === 200000) {
          const { data } = res;
          this.setState({
            AuthData: [...data],
          });
        }
      });
    };

    render() {
      return (
        <GetAuthDataValue.Provider value={this.state.AuthData}>
          <WrappedCom {...this.props} />
        </GetAuthDataValue.Provider>
      );
    }
  };
}

export { GetAuthDataValue, withGetAuthWraper };
